import * as Html from "../../util/Html.ts";
import * as validator from "./validator.ts";

Html.registerWidget('widget/form/textarea-onenter-submit',{initDom})

function keypresscontroller(this: HTMLTextAreaElement, evt){

  if(evt.keyCode===13 || evt.keyCode===10){
    if(evt.altKey || evt.ctrlKey  || evt.shiftKey ){
    }else{
      evt.preventDefault();
      this.form.requestSubmit();
    }
  }
}

function initDom(obj){
  validator.initDom(obj);
  obj.addEventListener('keypress',keypresscontroller);
}
